export const getFormattedAddress = (place?: {
  address: string;
  addressComponents: { companyName?: string };
}): string | null => {
  if (!place) {
    return null;
  }

  const { addressComponents, address } = place;

  if (address && addressComponents.companyName) {
    if (address.includes(addressComponents.companyName)) {
      return address;
    }
    return `${addressComponents.companyName}, ${address}`;
  }

  return address;
};
